import { texts } from "../lang/translations";
import type { LangKey } from "../types";

type Language = (typeof availableLanguages)[number];

type TranslateFn = {
	(textKey: LangKey, values: never): string;
	(textKey: LangKey, ...values: string[]): string;
};

const availableLanguages = ["sv"] as const;

const replaceVars = (langString: string, vars: RegExpMatchArray, values: string[]) =>
	vars.reduce(
		(prev, curr, index) => (values[index] ? prev.replace(curr, values[index]) : prev),
		langString,
	);

export const getTranslator =
	(lang: Language): TranslateFn =>
	(textKey: LangKey, ...values: string[]) => {
		const str = textKey?.[lang] || "";
		const vars = str.match(/\{[0-9]\}/g);

		if (vars && str && values.length) {
			return replaceVars(str, vars, values);
		}

		return str;
	};

export type TranslationTexts = typeof texts;

export const useText = (): [TranslateFn, TranslationTexts] => {
	const lang = "sv";

	return [getTranslator(lang), texts];
};
